import React from 'react';
import './App.css';
import './CSS/galaxy.css';
function App() {
  return (
    <div className="stars">

    </div>
  );
}

export default App;